import { pathgen } from 'object-path-generator';
import { useDuplicateRelationship } from "../../useDuplicateRelationship";
import { useStoreActions } from "../../../store/store-context";
import { useMutationState } from "../useMutationState";
export const useDuplicateProposalTestIds = pathgen('useDuplicateProposalTestIds');
export const useDuplicateProposal = function useDuplicateProposal() {
  let {
    onSuccess,
    withPageLoader
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    api
  } = useStoreActions();
  const {
    createDraftFromRelationship
  } = useDuplicateRelationship();
  const {
    mutate,
    isLoading
  } = useMutationState({
    mutationFn: async _ref => {
      let {
        draftId,
        relationshipId
      } = _ref;
      if (draftId) {
        return api.draft.duplicate(draftId);
      } else {
        return createDraftFromRelationship(relationshipId, {
          strategy: 'withdraw-to-edit'
        });
      }
    },
    withPageLoader,
    mutationName: 'duplicate-proposal',
    toasts: {
      successMessage: 'Proposal duplicated successfully',
      successTestId: useDuplicateProposalTestIds.SuccessToast(),
      errorMessage: 'Failed to duplicate proposal',
      errorTestId: useDuplicateProposalTestIds.ErrorToast()
    },
    onSuccess
  });
  return {
    duplicateProposal: mutate,
    isLoading
  };
};